import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { RevealTextOnView } from "../components/RevealText";
import RevealText from "../components/RevealText";
import { API_URL } from "../lib/brand";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/blog`).then((res) => {
      setPosts(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 md:pt-40 pb-16 px-6 md:px-10" data-testid="blog-page">
      <div className="max-w-[1600px] mx-auto">
        <p className="text-[10px] uppercase tracking-[0.4em] text-[#FF2768] mb-6">— Journal</p>
        <h1 className="font-display text-[14vw] md:text-[10vw] lg:text-[12rem] leading-[0.85] text-[#3D2140] mb-6">
          <RevealText text={["Parole per", "la famiglia."]} />
        </h1>
        <p className="max-w-2xl text-lg text-[#3D2140]/70 leading-relaxed mb-20 font-editorial text-2xl">
          Riflessioni, spunti e strumenti pratici — con la stessa cura con cui accompagno le persone in studio.
        </p>

        {loading && <p className="text-[#3D2140]/50">Caricamento…</p>}

        {!loading && posts.length === 0 && (
          <p className="text-[#3D2140]/60 text-lg">Nessun articolo ancora pubblicato.</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {posts.map((p, idx) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: (idx % 3) * 0.1 }}
              className={`group ${idx % 3 === 1 ? "lg:mt-16" : idx % 3 === 2 ? "lg:mt-8" : ""}`}
            >
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${idx}`}>
                <div className="aspect-[4/5] rounded-[24px] overflow-hidden mb-6 bg-[#81C3C9]/20 relative">
                  {p.cover_image ? (
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#81C3C9]/30 to-[#FF2768]/20">
                      <span className="font-display text-8xl text-[#3D2140]/30">TV</span>
                    </div>
                  )}
                  <span className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 group-hover:rotate-45">
                    <ArrowUpRight size={16} />
                  </span>
                </div>
                <div className="flex flex-wrap gap-2 mb-3">
                  {(p.tags || []).slice(0, 2).map((t) => (
                    <span key={t} className="text-[10px] uppercase tracking-widest text-[#FF2768] font-semibold">#{t}</span>
                  ))}
                </div>
                <h2 className="font-display text-4xl md:text-5xl text-[#3D2140] leading-[0.95] mb-3 group-hover:text-[#FF2768] transition-colors">
                  {p.title}
                </h2>
                <p className="text-[#3D2140]/70 leading-relaxed line-clamp-2">{p.excerpt}</p>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}
